import React, { useState } from 'react';
import PhotoCard from './PhotoCard';
import './photoGallery.css';
import Slider from 'react-slick';
import Modal from 'react-modal';

const PhotoGallery = ({ photoUrls }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedPhoto, setSelectedPhoto] = useState(null);

    const openModal = (photo) => {
        setSelectedPhoto(photo);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedPhoto(null);
    };

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: '0px',
        arrows: true,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerMode: false,
                    centerPadding: '0px',
                    arrows: true,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: false,
                    centerPadding: '0px',
                    arrows: true,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                    centerPadding: '0px',
                    arrows: true,
                }
            }
        ]
    };

    return (
        <div className="photo-gallery__container">
            <div className="photo-gallery__title-container">
                <h2>NUESTRA EMPRESA.</h2>
            </div>
            <Slider {...sliderSettings}> 
                {photoUrls.map((item) => (
                    <div key={item.id}>
                        <PhotoCard data={item} onClick={() => openModal(item)} />
                    </div>
                ))}
            </Slider>
            {isModalOpen && (
              <Modal
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                contentLabel="Photo Modal"
                className="photo-gallery__modal"
                overlayClassName="photo-gallery__modal-overlay"
              >
                <button onClick={closeModal} className="photo-gallery__modal-close-button">
                    x
                </button>
                <img src={selectedPhoto} alt="Selected" className="photo-gallery__modal-image" />
              </Modal>
            )}
        </div>
    );
};

export default PhotoGallery;
